import React, { useState, useEffect } from "react";

import { ReactTitle } from "react-meta-tags";
import { useHistory, useRouteMatch } from "react-router-dom";
import Modal from "../../../../utils/customModal";
import { getRoles } from "../../../../../Redux/reducer/session";
import BlankProvider from "../../providers/blankProviderBSC";
import plusImage from "../../../../../../static/images/plus.svg";
import { MOD_CUSTOM, WRITE } from "../../../../../permissions/";
import TableUsersByProvider from "../../../table/table-provider-users";
import * as userActions from "../../../../../Redux/actions/userActions";
import { getOneProvider } from "../../../../../Redux/reducer/providers";
import { getAllUsers, getTotalUsers } from "../../../../../Redux/reducer/users";
import {
  infoContainer,
  moduleAction,
  loadingHtml,
} from "../../../../utils/functions";
import ProviderUserInfo from "./providerUserInfo";
import { useDispatch, useSelector } from "react-redux";
import { useTranslation } from "react-i18next";

const ProviderUsers = () => {
  const [state, setState] = useState({
    modal: true,
    componentReady: false,
    page: 0,
    data: null,
    totalSize: 0,
    sizePerPage: 10,
    firstLoad: false,
    searchFilters: false,
    list: true,
    profile: false,
  });

  const [selectedUser, setSelectedUser] = useState({
    userCode: null,
    businessId: null,
    countryCode: null,
    userType: null,
  });

  const [modal, setModal] = useState({
    loading: false,
    show: false,
    content: null,
  });

  const { roles, users, totalElements, provider } = useSelector((state) => ({
    roles: getRoles(state),
    users: getAllUsers(state),
    totalElements: getTotalUsers(state),
    provider: getOneProvider(state),
  }));

  const dispatch = useDispatch();
  const history = useHistory();
  const match = useRouteMatch();

  const { t } = useTranslation();

  const getUsers = async () => {
    const { page, sizePerPage } = state;

    await dispatch(
      userActions.getUsersByInstitution(provider.id, page, sizePerPage, filter)
    );

    setState((prev) => ({
      ...prev,
      modal: false,
      componentReady: true,
      firstLoad: true,
    }));
  };

  const getUsersByInstitutionTable = (...params) =>
    dispatch(userActions.getUsersByInstitution(...params));

  const UsersProviderTable = () => {
    const { page, sizePerPage, firstLoad } = state;

    if (firstLoad || (users !== null && users.length > 0)) {
      return (
        <TableUsersByProvider
          getDetailUser={changeProfile}
          data={users}
          page={page}
          getUsersByInstitution={getUsersByInstitutionTable}
          institutionId={provider.id}
          totalSize={totalElements}
          sizePerPage={sizePerPage}
          updateNavigation={updateNavigation}
        />
      );
    } else return <BlankProvider />;
  };

  const updateNavigation = ({ page, sizePerPage }) => {
    setState((prev) => ({ ...prev, page, sizePerPage }));
  };

  const loadUsersProvider = () => {
    const { firstLoad } = state;

    return firstLoad || (users !== null && users.length > 0) ? (
      UsersProviderTable()
    ) : (
      <BlankProvider />
    );
  };

  const selRedirect = () => {
    history.push(
      `/bscadministrator/users/${provider.provider.id}/${match.params.companyId}/${provider.businessId}/${provider.country.code}/add`
    );
    setModal({ show: false, content: null });
  };

  const formRedirect = () => {
    history.push(
      `/bscadministrator/providers/${provider.id}/${provider.provider.id}/${match.params.companyId}/${provider.businessId}/${provider.country.code}/add-user`
    );
    setModal({ show: false, content: null });
  };

  const closeStep = () => {
    const country = provider.country.code;
    const buttons = {
      SelBtn: {
        text: "Si",
        action: selRedirect,
      },
      formBtn: {
        text: "No",
        action: formRedirect,
      },
    };

    const content = infoContainer(
      "Agregar usuario",
      `¿El usuario se encuentra dentro de ${
        country === "PA" ? `CAMS` : `Seguridad Electrónica`
      }?`,
      buttons
    );
    setModal({ content, show: true });
  };

  const closeModalInfo = () => {
    if (!modal.loading) setModal({ show: false, content: null });
  };

  const changeProfile = (item) => {
    setState((prev) => ({ ...prev, list: false, profile: true }));
    setSelectedUser({
      userCode: item.codUser,
      businessId: provider.businessId,
      countryCode: provider.country.code,
      userType: item.userType.code,
      reverseUser: item.authorizationCode !== null,
    });
  };

  const returnTable = () => {
    setState((prev) => ({ ...prev, list: true, profile: false }));
    getUsers();
  };

  useEffect(() => {
    getUsers();
  }, []);

  const { list, profile } = state;

  const hasPermissions = moduleAction(roles, MOD_CUSTOM, WRITE);

  return (
    <div className="bsc-users-provider">
      <ReactTitle title="Gestión de Proveedores - Usuarios" />
      {!profile && (
        <div className="header-title flex-element">
          <div className="title gest-client flex-element">
            <div className="client-gest subtitle">
              {t("clients.users.title")}
            </div>
          </div>
          <div className="actions flex-element">
            {hasPermissions && (
              <a className="add-button flex-element" onClick={closeStep}>
                <p className="bsc-add-client"> {t("clients.users.add_user")}</p>
                <img src={plusImage} />
              </a>
            )}
          </div>
        </div>
      )}
      {state.componentReady ? list && loadUsersProvider() : null}
      {profile && selectedUser.userCode && (
        <ProviderUserInfo user={selectedUser} returnTable={returnTable} />
      )}
      <Modal handleClose={closeModalInfo} show={modal.show} id="add-user-modal">
        <div className="molda-setting-content">{modal.content}</div>
      </Modal>
      <Modal show={state.modal}>{loadingHtml()}</Modal>
    </div>
  );
};

export default ProviderUsers;

const filter = [{ property: "user.userType.id", operator: "not", value: "2" }];
